// eslint-disable-next-line import/prefer-default-export
const asucData = [
  {
    category: 'Medical and service',
    name: 'Community Projects',
    years_of_sponsorship: 56,
    funding: '149,990.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Queer Alliance & Resource Center',
    years_of_sponsorship: 57,
    funding: '87,500.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Engineering Student Council',
    years_of_sponsorship: 35,
    funding: '75,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'UC Rally Committee',
    years_of_sponsorship: 125,
    funding: '68,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Sigma Alpha Nu',
    years_of_sponsorship: 15,
    funding: '3,050.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'California Mock Trial (Pre-waived travel)',
    years_of_sponsorship: 25,
    funding: '25,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Black Student Union',
    years_of_sponsorship: 16,
    funding: '22,500.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Muslim Student Association',
    years_of_sponsorship: 39,
    funding: '20,930.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'UC Berkeley Model UN',
    years_of_sponsorship: 34,
    funding: '15,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'Debate Society of Berkeley (pre-waived travel)',
    years_of_sponsorship: 13,
    funding: '14,990.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Chinese Student Association',
    years_of_sponsorship: 36,
    funding: '12,990.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Cinematic Arts and Production Club',
    years_of_sponsorship: 6,
    funding: '12,570.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'East Asian Union',
    years_of_sponsorship: 16,
    funding: '11,750.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'Undergraduate Moot Court Team',
    years_of_sponsorship: 5,
    funding: '11,325.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'The Berkeley Forum',
    years_of_sponsorship: 14,
    funding: '11,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'Berkeley Model United Nations Conference (Formerly known as Berkeley Model United Nations)',
    years_of_sponsorship: 6,
    funding: '10,670.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Cal Dragon Boat',
    years_of_sponsorship: 22,
    funding: '10,330.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'BARE Magazine',
    years_of_sponsorship: 18,
    funding: '9,730.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Community and culture',
    name: 'Iranian Students Cultural Organization',
    years_of_sponsorship: 27,
    funding: '9,670.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Alternative Breaks',
    years_of_sponsorship: 23,
    funding: '9,670.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Art and performance',
    name: 'Fashion and Student Trends',
    years_of_sponsorship: 14,
    funding: '8,750.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Pilipino American Alliance',
    years_of_sponsorship: 35,
    funding: '8,330.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Indian Students Association',
    years_of_sponsorship: 22,
    funding: '8,070.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Southeast Asian Student Coalition',
    years_of_sponsorship: 18,
    funding: '8,070.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Bears for Palestine',
    years_of_sponsorship: 11,
    funding: '7,490.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Business and tech',
    name: 'Biofuels Technology Club',
    years_of_sponsorship: 7,
    funding: '7,350.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'American Red Cross at Cal',
    years_of_sponsorship: 21,
    funding: '7,070.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Nigerian Students Association',
    years_of_sponsorship: 7,
    funding: '7,030.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Threads',
    years_of_sponsorship: 26,
    funding: '6,800.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Community and culture',
    name: 'Vietnamese Student Association',
    years_of_sponsorship: 34,
    funding: '6,730.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Academic',
    name: 'American Chemical Society at Berkeley Student Chapter',
    years_of_sponsorship: 10,
    funding: '6,510.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'UC Jazz Ensemble',
    years_of_sponsorship: 37,
    funding: '6,500.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Bearettes Drill Team at Berkeley',
    years_of_sponsorship: 8,
    funding: '6,470.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Berkeley Political Review, The',
    years_of_sponsorship: 23,
    funding: '6,440.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Academic',
    name: 'Mathematics Undergraduate Student Association',
    years_of_sponsorship: 9,
    funding: '6,250.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Cal Taiko',
    years_of_sponsorship: 21,
    funding: '6,200.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Pilipino Association for Health Careers',
    years_of_sponsorship: 33,
    funding: '5,880.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Comunidad for Health Equity',
    years_of_sponsorship: 35,
    funding: '5,630.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Volunteer Health Interpreters Organization',
    years_of_sponsorship: 19,
    funding: '5,520.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Asha For Education, Berkeley',
    years_of_sponsorship: 20,
    funding: '5,470.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Sikh Students Association',
    years_of_sponsorship: 24,
    funding: '5,390.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Publication',
    name: 'Heuristic Squelch, The',
    years_of_sponsorship: 29,
    funding: '5,280.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Community and culture',
    name: 'Pakistani Student Association',
    years_of_sponsorship: 21,
    funding: '5,250.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'South Indian Society',
    years_of_sponsorship: 10,
    funding: '5,230.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Berkeley Medical Reserve Corps',
    years_of_sponsorship: 12,
    funding: '5,230.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Cal Berkeley Democrats',
    years_of_sponsorship: 28,
    funding: '5,200.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'MOVE: AA Community Organizing Fellowship (Formerly known as: MOVE: API Organizing Fellowship)',
    years_of_sponsorship: 8,
    funding: '5,050.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Art and performance',
    name: 'Salsa at Cal',
    years_of_sponsorship: 12,
    funding: '5,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Thrive Dance Company',
    years_of_sponsorship: 12,
    funding: '5,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Cal Hiking and Outdoor Society',
    years_of_sponsorship: 77,
    funding: '5,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Health and Medical Apprenticeship Program',
    years_of_sponsorship: 42,
    funding: '5,000.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'California Mock Trial',
    years_of_sponsorship: 25,
    funding: '5,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Circle K International',
    years_of_sponsorship: 31,
    funding: '4,930.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Pointe of Berkeley',
    years_of_sponsorship: 9,
    funding: '4,860.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Intermission Orchestra, The',
    years_of_sponsorship: 7,
    funding: '4,750.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'BridgeUSA at Berkeley',
    years_of_sponsorship: 8,
    funding: '4,670.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'AFX Dance',
    years_of_sponsorship: 13,
    funding: '4,640.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Azaad',
    years_of_sponsorship: 7,
    funding: '4,600.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Southeast Asian Mentorship',
    years_of_sponsorship: 16,
    funding: '4,600.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Art and performance',
    name: 'Ballet Company At Berkeley',
    years_of_sponsorship: 14,
    funding: '4,430.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Cal Hawai’i Club',
    years_of_sponsorship: 37,
    funding: '4,400.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'acts2fellowship',
    years_of_sponsorship: 24,
    funding: '4,280.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Asian American Association',
    years_of_sponsorship: 28,
    funding: '4,230.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Natya at Berkeley',
    years_of_sponsorship: 12,
    funding: '4,210.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Mariachi Luz de Oro',
    years_of_sponsorship: 12,
    funding: '4,100.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'To An Unknown God',
    years_of_sponsorship: 16,
    funding: '4,030.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Art and performance',
    name: 'Artists in Resonance',
    years_of_sponsorship: 11,
    funding: '3,930.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'Debate Society of Berkeley',
    years_of_sponsorship: 13,
    funding: '3,910.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'Parliamentary Debate at Berkeley',
    years_of_sponsorship: 15,
    funding: '3,830.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Bear Power Fund',
    years_of_sponsorship: 6,
    funding: '3,800.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'The Period Project at Berkeley',
    years_of_sponsorship: 6,
    funding: '3,600.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Taiwanese American Student Association',
    years_of_sponsorship: 28,
    funding: '3,590.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Caravan Travel & Style Magazine',
    years_of_sponsorship: 8,
    funding: '3,560.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Community and culture',
    name: 'Nikkei Student Union',
    years_of_sponsorship: 23,
    funding: '3,500.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Diaspora Magazine',
    years_of_sponsorship: 4,
    funding: '3,350.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Business and tech',
    name: 'Blueprint, Technology for Nonprofits',
    years_of_sponsorship: 12,
    funding: '3,330.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'InterVarsity Christian Fellowship',
    years_of_sponsorship: 27,
    funding: '3,200.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Hmong Student Association at Berkeley',
    years_of_sponsorship: 18,
    funding: '3,140.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Bhagat Puran Singh Health Initiative at Berkeley',
    years_of_sponsorship: 10,
    funding: '3,130.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Art and performance',
    name: 'The [M]ovement',
    years_of_sponsorship: 25,
    funding: '3,120.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Main Stacks Dance Team',
    years_of_sponsorship: 4,
    funding: '3,070.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Berkeley Fiction Review',
    years_of_sponsorship: 42,
    funding: '3,050.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Academic',
    name: 'Undergraduate Lab at Berkeley (ULAB)',
    years_of_sponsorship: 6,
    funding: '3,030.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Arnold Air Society',
    years_of_sponsorship: 8,
    funding: '3,010.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Lambda Theta Phi, Latin Fraternity, Inc.',
    years_of_sponsorship: 18,
    funding: '3,000.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Publication',
    name: 'Berkeley Scientific Journal',
    years_of_sponsorship: 9,
    funding: '3,000.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Quidditch League at Berkeley',
    years_of_sponsorship: 17,
    funding: '3,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'PreDental Society',
    years_of_sponsorship: 42,
    funding: '2,930.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Berkeley College Republicans',
    years_of_sponsorship: 29,
    funding: '2,820.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Cal Japan Club',
    years_of_sponsorship: 18,
    funding: '2,770.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Ra-On',
    years_of_sponsorship: 15,
    funding: '2,760.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'DeCadence',
    years_of_sponsorship: 25,
    funding: '2,750.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Taiwanese Student Association',
    years_of_sponsorship: 29,
    funding: '2,730.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: "Rubik's Cube Club at Berkeley",
    years_of_sponsorship: 14,
    funding: '2,670.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Public speaking and debate',
    name: 'UC Berkeley Model UN (Waived travel)',
    years_of_sponsorship: 34,
    funding: '2,670.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Historical Fencing Club of Berkeley',
    years_of_sponsorship: 7,
    funding: '2,600.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Turkish Student Association at Berkeley',
    years_of_sponsorship: 8,
    funding: '2,590.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Berkeley Chinese Students and Scholars Association',
    years_of_sponsorship: 19,
    funding: '2,490.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Fei Tian Dancers',
    years_of_sponsorship: 20,
    funding: '2,330.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Blue and Gold Yearbook',
    years_of_sponsorship: 11,
    funding: '2,330.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Medical and service',
    name: 'Paws for Mental Health',
    years_of_sponsorship: 7,
    funding: '2,280.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Patient Advocacy Student Group',
    years_of_sponsorship: 14,
    funding: '2,270.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Volunteer Income Tax Assistance Program',
    years_of_sponsorship: 13,
    funding: '2,270.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Kidney Disease Screening and Awareness Program',
    years_of_sponsorship: 9,
    funding: '2,190.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Jugger At Berkeley',
    years_of_sponsorship: 8,
    funding: '2,120.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Laya of Berkeley',
    years_of_sponsorship: 7,
    funding: '2,110.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Microfinance at Berkeley',
    years_of_sponsorship: 13,
    funding: '2,110.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'MEDLIFE',
    years_of_sponsorship: 15,
    funding: '2,080.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Indus',
    years_of_sponsorship: 36,
    funding: '2,030.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Labor Coach Program',
    years_of_sponsorship: 14,
    funding: '2,030.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Arab Student Union',
    years_of_sponsorship: 14,
    funding: '2,010.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Raas Ramzat',
    years_of_sponsorship: 9,
    funding: '1,930.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Danceworx',
    years_of_sponsorship: 28,
    funding: '1,920.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Tri-Service Corps of Cadets',
    years_of_sponsorship: 5,
    funding: '1,900.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Political Computer Science',
    years_of_sponsorship: 6,
    funding: '1,890.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Hong Kong Student Association',
    years_of_sponsorship: 31,
    funding: '1,830.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Students for Life at Berkeley',
    years_of_sponsorship: 28,
    funding: '1,790.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Cal in the Capital',
    years_of_sponsorship: 47,
    funding: '1,730.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Punjabis at Berkeley',
    years_of_sponsorship: 1,
    funding: '1,670.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: "American Medical Women's Association at Berkeley",
    years_of_sponsorship: 10,
    funding: '1,600.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Malaysian Student Association at Berkeley',
    years_of_sponsorship: 3,
    funding: '1,590.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Pre-Medical Honor Society',
    years_of_sponsorship: 9,
    funding: '1,570.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'KOSMOS',
    years_of_sponsorship: 5,
    funding: '1,570.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'American Medical Students Association: Berkeley Premedical Chapter',
    years_of_sponsorship: 27,
    funding: '1,560.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Molecular and Cell Biology Undergraduate Student Association',
    years_of_sponsorship: 11,
    funding: '1,530.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Singapore Student Association',
    years_of_sponsorship: 6,
    funding: '1,520.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Outlet',
    years_of_sponsorship: 12,
    funding: '1,470.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Nikkei Choral Ensemble',
    years_of_sponsorship: 9,
    funding: '1,400.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Asian American Research Journal',
    years_of_sponsorship: 5,
    funding: '1,400.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Community and culture',
    name: 'Central Americans for Empowerment (CAFE) at UC Berkeley',
    years_of_sponsorship: 8,
    funding: '1,390.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Kappa Gamma Delta',
    years_of_sponsorship: 13,
    funding: '1,390.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Vagabond Multilingual Journal',
    years_of_sponsorship: 4,
    funding: '1,350.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Academic',
    name: 'Pre-Pharmacy Informational, Learning and Leadership Society',
    years_of_sponsorship: 25,
    funding: '1,330.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Berkeley Economic Review',
    years_of_sponsorship: 6,
    funding: '1,270.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Art and performance',
    name: 'Chinese A Cappella at Berkeley',
    years_of_sponsorship: 10,
    funding: '1,250.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Undergraduate Real Estate Club',
    years_of_sponsorship: 11,
    funding: '1,250.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Partnership for Pre-Professional Pilipinxs',
    years_of_sponsorship: 25,
    funding: '1,220.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'American Institute of Architecture Students',
    years_of_sponsorship: 15,
    funding: '1,210.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Creative Residencies for Emerging Artists Teaching Empowerment',
    years_of_sponsorship: 13,
    funding: '1,200.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Berkeley Disaster Team',
    years_of_sponsorship: 10,
    funding: '1,200.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'AAAA - Furries at Berkeley',
    years_of_sponsorship: 4,
    funding: '1,150.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Alpha Phi Omega',
    years_of_sponsorship: 38,
    funding: '1,130.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'maganda magazine',
    years_of_sponsorship: 35,
    funding: '1,100.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Art and performance',
    name: 'T.I.n.Y. Chinese Theatre Group',
    years_of_sponsorship: 9,
    funding: '1,060.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'The Environmentalist',
    years_of_sponsorship: 3,
    funding: '1,050.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Art and performance',
    name: 'Argentine Tango Club of Berkeley',
    years_of_sponsorship: 6,
    funding: '1,030.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Data Science Society at Berkeley',
    years_of_sponsorship: 10,
    funding: '1,030.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Her Campus of Berkeley',
    years_of_sponsorship: 5,
    funding: '1,030.00',
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Academic',
    name: 'Sports Analytics Group at Berkeley',
    years_of_sponsorship: 6,
    funding: '1,020.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'International Students Association at Berkeley',
    years_of_sponsorship: 25,
    funding: '1,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Eggster Organization',
    years_of_sponsorship: 25,
    funding: '1,000.00',
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Sigma Pi Alpha Sorority, Inc.',
    years_of_sponsorship: 16,
    funding: '1,000.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Lambda Theta Nu Sorority, Inc.',
    years_of_sponsorship: 15,
    funding: '1,000.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Delta Epsilon Mu Inc. (Alpha Psi Chapter)',
    years_of_sponsorship: 5,
    funding: '1,000.00',
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Alpha Epsilon Zeta Fraternity, Inc.',
    years_of_sponsorship: 19,
    funding: 970,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Ballet Folklorico Reflejos del Sol',
    years_of_sponsorship: 12,
    funding: 960,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Aglet Noise Collective',
    years_of_sponsorship: 3,
    funding: 950,
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Community and culture',
    name: 'Sri Lankans at Berkeley',
    years_of_sponsorship: 2,
    funding: 940,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: '3D Modeling and Animation at Berkeley',
    years_of_sponsorship: 7,
    funding: 910,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Spoon University at Berkeley',
    years_of_sponsorship: 11,
    funding: 850,
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Publication',
    name: 'Fellowship in Christ Berkeley',
    years_of_sponsorship: 4,
    funding: 850,
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Publication',
    name: 'Comparative Literature Publication Association',
    years_of_sponsorship: 3,
    funding: 850,
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Publication',
    name: 'BrainScramble Magazine at Berkeley',
    years_of_sponsorship: 2,
    funding: 850,
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Professional frat',
    name: 'Kappa Alpha Pi Pre Law Fraternity',
    years_of_sponsorship: 10,
    funding: 840,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Kendo Club at Berkeley',
    years_of_sponsorship: 10,
    funding: 830,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Undergraduate Economics Association',
    years_of_sponsorship: 25,
    funding: 800,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'TBD Comedy',
    years_of_sponsorship: 9,
    funding: 800,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Association of Korean Artists',
    years_of_sponsorship: 6,
    funding: 790,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Kairos Christian Fellowship',
    years_of_sponsorship: 1,
    funding: 790,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Delta Kappa Alpha',
    years_of_sponsorship: 2,
    funding: 790,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Aurum Cosmetics',
    years_of_sponsorship: 7,
    funding: 770,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Phi Delta Epsilon',
    years_of_sponsorship: 15,
    funding: 770,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Khmer Student Association',
    years_of_sponsorship: 2,
    funding: 760,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Student Nutrition Advocacy Club',
    years_of_sponsorship: 5,
    funding: 760,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Psychedelic Science at Berkeley',
    years_of_sponsorship: 6,
    funding: 750,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Spring Foundation',
    years_of_sponsorship: 11,
    funding: 750,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Students for Comprehensive Healthcare',
    years_of_sponsorship: 3,
    funding: 750,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'BUILD Literacy Program',
    years_of_sponsorship: 6,
    funding: 730,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'International Healthcare Association',
    years_of_sponsorship: 6,
    funding: 730,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Quiz Bowl Club',
    years_of_sponsorship: 3,
    funding: 700,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Chemistry Undergraduate Research Initiative and Enrichment at Berkeley',
    years_of_sponsorship: 1,
    funding: 700,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Game Design and Development at Berkeley',
    years_of_sponsorship: 7,
    funding: 700,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Gender Equity in Mathematics at Berkeley',
    years_of_sponsorship: 11,
    funding: 690,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Berkeley Carillon Guild',
    years_of_sponsorship: 1,
    funding: 690,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Berkeley Environmental Economics and Policy Society',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'BioethiCAL',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Code For Good',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Latine Pre-Law Society (formerly known as Latinx Pre-Law Society)',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'NewSpace at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'SDG Undergraduate Research Group',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'American Sign Language at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'BERKE1337 Cyber Security Team',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Codify',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Diversity and Inclusion in Real Estate',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Science Olympiad at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Surge - Electric Motorcycles at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'American Physician Scientist Association at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'B PsychEd',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Career Readiness Program at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Academic',
    name: 'Engineers Without Borders at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Academic',
    name: 'English Undergraduate Association',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Health, Education, and Life',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Academic',
    name: 'History of Art Undergraduate Association',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Media Studies Student Association',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Society of Physics Students at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Undergraduate Astronomy Society',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Undergraduate Biotech Association',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Archaeology Club Of Berkeley',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Dance Games at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Rhythm at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Aerial Arts at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Celerity Traditional Dance Team',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Expansion Pictures',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'LUXX',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Nazakat at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'TrueLement',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Yarn Arts at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Freestyles at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Noteworthy A Cappella',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Public School Records',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'REVERB',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'BareStage Productions',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Unwind',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Association for Socially Responsible Business',
    years_of_sponsorship: 8,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'International Consulting Club at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'AI Entrepreneurs Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Azure',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Open Project',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Anre AI Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'GlamourGals',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Undergraduate Private Equity Club at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Women in Computing and Data Science at Berkeley',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Afghan Student Association',
    years_of_sponsorship: 16,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Fiat Lux Scholars Association',
    years_of_sponsorship: 9,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Saudi Arabian Association at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Speaker Series: India at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Thai American Cultural Association',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'African Inclusivity and Solidarity Association (formerly Organization of African Students)',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'African Maghreb Student Union',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Armenian Students Association',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Brazilian Student Association at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Dutch Student Association at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Eritrean-Ethiopian Student Association',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Hermanas Unidas de UC Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Iraqi Student Union',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Polish Club of Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Community and culture',
    name: 'Soon Movement Global',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'North Indian Student Association',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: "Women's Network at Berkeley",
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Creative Applications to Life in Origami',
    years_of_sponsorship: 11,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Bears for Birds - Audubon at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Board Games at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Coffee Club at Berkeley (CCB)',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Outsiders',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Taylor Swift Society of Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Ballet & Books at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Hobby',
    name: 'Fighting Games at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Kink Club',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Mahjong Club',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'OPEN at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Riot Games at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Splatoon at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'The Wildlife Society at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Brick by Brick at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Chess Club at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Standup Comedy (at Berkeley)',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'EthiCal Apparel',
    years_of_sponsorship: 16,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'American Lung Cancer Screening Initiative at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Americas ToothFairy at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'CASCADE: Community Service',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Detrash@Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Educate a Child for Change Organization at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'G.I.F.T.E.D. (Give to Inspire the Future of Talented, Educated Doctors) Pre-Med',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Global Medical Training',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Imago Dei Clinic',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Mycology Club at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Students vs Pandemics at Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Asian Community Health',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Collaborative Dorms Society',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Fighting Cancer at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Junior Care Clinic at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Sustainable Entrepreneurship at Berkeley',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Bamboo Abroad at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Brighter Smiles Initiative',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Elder Welfare Mentorship',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'HOSA Future Health Professionals of Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'IDEAS at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Telegraph For People',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Common Cause at Berkeley',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'alpha Kappa Delta Phi',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'Atrium',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Publication (PUB)',
  },
  {
    category: 'Publication',
    name: 'Free Peach, The',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Publication',
    name: 'The Dialectic',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Berkeley Tennis Association (Formerly Tennis at Cal)',
    years_of_sponsorship: 8,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Cricket Club of Berkeley',
    years_of_sponsorship: 4,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Logging Sports Team',
    years_of_sponsorship: 3,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Hurling Club at Berkeley',
    years_of_sponsorship: 2,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Army ROTC Cadet Club',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Black Student Athlete Community of Berkeley',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'SCUBA at Berkeley',
    years_of_sponsorship: 1,
    funding: 650,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Environmental Sciences Student Association',
    years_of_sponsorship: 4,
    funding: 640,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Student to Student Peer Counseling',
    years_of_sponsorship: 33,
    funding: 640,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Phi Alpha Delta Law Fraternity, International',
    years_of_sponsorship: 16,
    funding: 610,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'American Advertising Federation',
    years_of_sponsorship: 10,
    funding: 600,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Theater For Charity',
    years_of_sponsorship: 22,
    funding: 580,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Korean Performance Group',
    years_of_sponsorship: 10,
    funding: 570,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Jakara Movement Club',
    years_of_sponsorship: 8,
    funding: 570,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'California Health Professional Student Alliance at Berkeley',
    years_of_sponsorship: 8,
    funding: 570,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Power of a Princess',
    years_of_sponsorship: 5,
    funding: 570,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Art and performance',
    name: 'Lindy on Sproul',
    years_of_sponsorship: 15,
    funding: 560,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Latin American Leadership Society',
    years_of_sponsorship: 11,
    funding: 560,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Cal Pre-Vet Club',
    years_of_sponsorship: 15,
    funding: 560,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Palestinian Public Health at UC Berkeley',
    years_of_sponsorship: 5,
    funding: 560,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'The Berkeley Group',
    years_of_sponsorship: 23,
    funding: 550,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Cal American Civil Liberties Union',
    years_of_sponsorship: 9,
    funding: 540,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Drawn to Scale',
    years_of_sponsorship: 12,
    funding: 530,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Design At Berkeley',
    years_of_sponsorship: 5,
    funding: 530,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Undergraduate Women in Economics',
    years_of_sponsorship: 7,
    funding: 530,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'DataGood at Berkeley',
    years_of_sponsorship: 5,
    funding: 530,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Foresight Pre-Optometry Club',
    years_of_sponsorship: 32,
    funding: 530,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Lean On Me at Berkeley',
    years_of_sponsorship: 6,
    funding: 520,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Academic',
    name: 'Society of Linguistics Undergraduate Students',
    years_of_sponsorship: 6,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'California Public Interest Research Group',
    years_of_sponsorship: 5,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Academic',
    name: 'TransferMD@Berkeley',
    years_of_sponsorship: 3,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Aspiring Educators at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Berkeley Legal Studies Association',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'LeetCode at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Neuroscience Club at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Toxicology Student Association',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Berkeley Urban Studies Student Association',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Black Pre-Dental Association',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Molecular Environmental Biology at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Mood Psychology at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Berkeley Ballroom Dancers',
    years_of_sponsorship: 11,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Phoenix Symphony at Berkeley',
    years_of_sponsorship: 10,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Tether Dance Company',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'The Beauty Hub at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Shakespeare Society of Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'The 510',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Untitled Theater Company',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Neurotechnology at Berkeley',
    years_of_sponsorship: 5,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Venture Capital at Berkeley',
    years_of_sponsorship: 5,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Scholars of Finance',
    years_of_sponsorship: 4,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Cal Actuarial League',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Sustainable Internet Lab',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'TechFounders at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Cub Consulting at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Bangali Student Association at Berkeley',
    years_of_sponsorship: 8,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: "For Christ's Sake",
    years_of_sponsorship: 6,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: "Prytanean Women's Honor Society",
    years_of_sponsorship: 3,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Unity in Christ',
    years_of_sponsorship: 3,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Ahlul Bayt Student Association of Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Central Asian Student Association at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Christians on Campus',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Nepali Student Association at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Association of Latino Professionals for America at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Chicanx/Latinx Architecture Student Association',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Laotian American Student Representatives',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: "Phil and Sophie's Club at Berkeley",
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Women and Youth Supporting Each Other',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Hobby',
    name: 'Bioprinting at Berkeley',
    years_of_sponsorship: 7,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Air Bears - Skydiving Club at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'CALICO Informatics Competition',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'The Rebel Alliance of California',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Bootleg Comedy',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Redline at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'FeelGood',
    years_of_sponsorship: 6,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Down Syndrome Community Outreach at Berkeley',
    years_of_sponsorship: 4,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Kids in Nutrition',
    years_of_sponsorship: 4,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'United For Health at Berkeley',
    years_of_sponsorship: 3,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Flying Samaritans: Berkeley Satellite',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Global Health Brigades at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Good Grief at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Improv4Charity',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Operation Smile at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'ReUSE',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Student Policy Institute at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'University Housing Rights Organization',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'American Cancer Society of Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'End Overdose at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Food, Equity, Entrepreneurship, & Development',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Inside the Living Room',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Liberty in North Korea at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Project Sunshine at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Students for International Labor Solidarity at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Medical and service',
    name: 'Team HBV at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'We Kids United at Berkeley',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Delta Phi Epsilon Co-ed Professional Foreign Service Fraternity',
    years_of_sponsorship: 3,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Gamma Rho Lambda',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Multi-Cultural Greek Council',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
  {
    category: 'Professional frat',
    name: 'Phi Beta Sigma Fraternity, Inc.',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Professional frat',
    name: 'Sigma Mu Delta',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Kickboxing at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Swim Club at Berkeley',
    years_of_sponsorship: 2,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Cal Running Club',
    years_of_sponsorship: 1,
    funding: 500,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Berkeley Organization for Animal Advocacy',
    years_of_sponsorship: 10,
    funding: 470,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Students for Justice in Palestine',
    years_of_sponsorship: 1,
    funding: 450,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Art and Mind',
    years_of_sponsorship: 8,
    funding: 430,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Academic',
    name: 'Berkeley Energy and Resources Collaborative Undergraduate',
    years_of_sponsorship: 1,
    funding: 400,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Abba Modern',
    years_of_sponsorship: 9,
    funding: 370,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Tokiha',
    years_of_sponsorship: 1,
    funding: 360,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'International Software Product Management Association at Berkeley',
    years_of_sponsorship: 3,
    funding: 350,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Love Stories Book Club',
    years_of_sponsorship: 2,
    funding: 350,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Student Organic Gardening Association',
    years_of_sponsorship: 1,
    funding: 350,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Art and performance',
    name: 'Dil Se',
    years_of_sponsorship: 10,
    funding: 310,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Business and tech',
    name: 'Computer Science Mentors',
    years_of_sponsorship: 10,
    funding: 290,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Community and culture',
    name: 'Le Cercle Français of Berkeley',
    years_of_sponsorship: 9,
    funding: 260,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Student-Athletes in Medicine',
    years_of_sponsorship: 1,
    funding: 250,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: "Women's Baseball Club at Berkeley",
    years_of_sponsorship: 3,
    funding: 250,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: 'Korean American Basketball Association',
    years_of_sponsorship: 2,
    funding: 250,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Sports, spirit and rotc',
    name: "Women's Club Basketball at Berkeley",
    years_of_sponsorship: 2,
    funding: 250,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Hobby',
    name: 'Jericho!',
    years_of_sponsorship: 20,
    funding: 240,
    asuc_category: 'Student Activity Group (SAG)',
  },
  {
    category: 'Medical and service',
    name: 'Friends of MSF at Berkeley',
    years_of_sponsorship: 3,
    funding: 70,
    asuc_category: 'Student-Initiated Service Group (SISG)',
  },
];

export default asucData;
